import { memo } from 'react';
import { useNpsContext } from '../contexts/Nps.context';
import { NpsViewType } from '../nps.types';
import NpsContactMeForm from './NpsContactMeForm';
import NpsScoreForm from './NpsScoreForm';
import NpsThanksMessage from './NpsThanksMessage';

const NpsContainerContent = () => {
  const { view } = useNpsContext();

  switch (view) {
    case NpsViewType.ScoreForm:
      return <NpsScoreForm />;
    case NpsViewType.ContactForm:
      return <NpsContactMeForm />;
    case NpsViewType.ThanksMessage:
      return <NpsThanksMessage />;
    default:
      return <></>;
  }
};

export default memo(NpsContainerContent);
